import { yupResolver } from "@hookform/resolvers/yup";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import "flatpickr/dist/themes/material_blue.css";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useToasts } from "react-toast-notifications";
import { Button, Col, Form, Label, Row } from "reactstrap";
import * as yup from "yup";
import {
  useCreateCustomerSchedules,
  useUpdateCustomerSchedules,
} from "../../../hooks";
import { formatToScheduleTime, getCurScheduleTime } from "../utils";
import TimePicker from "./TimePicker";

const CustomerSchedulesForm = ({
  isModeCreate,
  schedules,
  customerId,
  onSuccess,
  ...props
}) => {
  const { t } = useTranslation(["customer"]);

  const { addToast } = useToasts();

  const listSchedulesDay = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

  const prefixStartApi = "from_time_";
  const prefixEndApi = "to_time_";

  const suffixLabelApi = "_label";

  const initDefaultValues = {
    customer_id: schedules?.customer_id || customerId,
  };
  const onCustomerSchedulesSuccess = data => {
    onSuccess?.(data.data);
  };

  const {
    mutate: onCreateCustomerSchedules,
    isLoading: isLoadingCreateCustomerSchedules,
  } = useCreateCustomerSchedules(onCustomerSchedulesSuccess);

  const onErrorUpdateCustomerSchedules = error => {
    if (error.code === 422 && error.fields.length > 0) {
      error.fields.forEach(item => {
        switch (item.field) {
          default:
            addToast(item.message, {
              appearance: "error",
              autoDismiss: true,
              autoDismissTimeout: 10000,
            });
            break;
        }
      });
    }
  };
  const {
    mutate: onUpdateCustomerSchedules,
    isLoading: isLoadingUpdateCustomerSchedules,
  } = useUpdateCustomerSchedules(
    onCustomerSchedulesSuccess,
    onErrorUpdateCustomerSchedules
  );
  let objSchema = {};
  listSchedulesDay.map(fieldDay => {
    const fieldNameStart = `${prefixStartApi}${fieldDay}`;
    const fieldNameEnd = `${prefixEndApi}${fieldDay}`;
    objSchema[fieldNameStart] = yup.date().nullable();
    objSchema[fieldNameEnd] = yup
      .date()
      .when(fieldNameStart, (startTime, schema) => {
        // 'startTime' is the value of the 'startTime' field
        // 'schema' is the yup schema object
        return schema.test({
          name: fieldNameEnd,
          exclusive: true, // Ensures 'endTime' is not equal to 'startTime'
          message: t("form.validate.errorStartEndTime"),
          test: function (endTime) {
            if (startTime || endTime) {
              return endTime > startTime;
            }
            return true;
          },
        });
      })
      .nullable();
  });

  const schema = yup.object().shape(objSchema);

  const {
    handleSubmit,
    formState: { errors, touchedFields, isSubmitting, isDirty },
    control,
    setValue,
    getValues,
    register,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });

  const handleSubmitForm = () => {
    trigger();
    handleSubmit(() => {
      const data = getValues();
      const objectDays = {};
      listSchedulesDay.map(fieldDay => {
        const fieldNameStart = `${prefixStartApi}${fieldDay}`;
        const fieldNameEnd = `${prefixEndApi}${fieldDay}`;
        // Start data
        const dayStart = data[fieldNameStart];
        if (dayStart) {
          objectDays[fieldNameStart] = formatToScheduleTime(dayStart);
        }
        // End data
        const dayEnd = data[fieldNameEnd];
        if (dayEnd) {
          objectDays[fieldNameEnd] = formatToScheduleTime(dayEnd);
        }
      });
      console.log(
        "🚀 ~ file: CustomerSchedulesForm.js:93 ~ handleSubmit ~ data:",
        objectDays
      );
      if (isModeCreate) {
        onCreateCustomerSchedules({
          id_customer: customerId,
          data: objectDays,
        });
      } else {
        onUpdateCustomerSchedules({
          id_schedules: schedules.id,
          id_customer: customerId,
          data: objectDays,
        });
      }
    })();
  };

  useEffect(() => {
    console.log("errors", errors);
  }, [errors]);

  useEffect(() => {
    if (schedules) {
      listSchedulesDay.map(fieldDay => {
        const fieldName = `${fieldDay}${suffixLabelApi}`;

        const fieldNameStart = `${prefixStartApi}${fieldDay}`;
        const fieldNameEnd = `${prefixEndApi}${fieldDay}`;

        if (schedules[fieldName]) {
          // Start time
          const dataStart = getCurScheduleTime(
            schedules[fieldName]?.split("-")[0]
          );
          setValue(fieldNameStart, dataStart);
          // End time
          const dataEnd = getCurScheduleTime(
            schedules[fieldName]?.split("-")[1]
          );
          setValue(fieldNameEnd, dataEnd);
        }
      });
    }
  }, [schedules]);

  return (
    <Form className="p-4 customer-schedules-form">
      <Row>
        <Col>
          <div className="d-flex  gap-3">
            <div style={{ width: "55px" }}></div>
            <div style={{ width: "100px", marginLeft: "5px" }}>
              <Label> {t("form.schedules.startTimeLabel")}</Label>
            </div>
            <div style={{ width: "100px", marginLeft: "5px" }}>
              <Label> {t("form.schedules.endTimeLabel")}</Label>
            </div>
          </div>
        </Col>
      </Row>
      <Row xs={1} md={1} style={{ gap: "10px" }}>
        {listSchedulesDay.map(fieldDay => {
          const fieldNameStart = `${prefixStartApi}${fieldDay}`;
          const fieldNameEnd = `${prefixEndApi}${fieldDay}`;
          return (
            <Col>
              <div className="d-flex align-items-center gap-3">
                <div style={{ width: "55px" }}>
                  <Label htmlFor="group_code" style={{ marginBottom: "0px" }}>
                    {t(`form.schedules.${fieldDay}`)}
                  </Label>
                </div>
                <div style={{ width: "100px" }}>
                  <TimePicker
                    name={fieldNameStart}
                    control={control}
                    errors={errors}
                  />
                </div>
                <div style={{ width: "100px", marginLeft: "2px" }}>
                  {" "}
                  <TimePicker
                    name={fieldNameEnd}
                    control={control}
                    errors={errors}
                  />
                </div>
                {(watch(fieldNameStart) || watch(fieldNameEnd)) && (
                  <div
                    className="btn btn-link"
                    onClick={() => {
                      setValue(fieldNameStart, null);
                      setValue(fieldNameEnd, null);
                    }}
                  >
                    <i className="fas fa-trash fa-lg text-danger"></i>
                  </div>
                )}
              </div>
              {errors[fieldNameStart] && (
                <div style={{ marginLeft: "71px" }}>
                  <MessageFormValidate error={errors[fieldNameStart].message} />
                </div>
              )}
              {errors[fieldNameEnd] && (
                <div style={{ marginLeft: "71px" }}>
                  <MessageFormValidate error={errors[fieldNameEnd].message} />
                </div>
              )}
            </Col>
          );
        })}
      </Row>
      <Row className="mt-3">
        <Col>
          <Button
            color="danger"
            outline
            className="border-0"
            size="xs"
            onClick={props?.handleCancel}
          >
            {t("form.cancel")}
          </Button>
        </Col>
        <Col className="text-end">
          <Button
            size="xs"
            color="primary"
            style={{ backgroundColor: "#3C64B1" }}
            onClick={handleSubmitForm}
            disabled={
              isLoadingUpdateCustomerSchedules ||
              isLoadingCreateCustomerSchedules
            }
          >
            {!isModeCreate ? t("form.update") : t("form.save")}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};
export default CustomerSchedulesForm;
